import { useEffect, useState } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import NomsOpenBanner from "@/components/NomsOpenBanner";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Classes from "@/components/Classes";
import Events from "@/components/Events";
import Volunteer from "@/components/Volunteer";
import News from "@/components/News";
import Membership from "@/components/Membership";
import NominateModal from "@/components/NominateModal";
import ContactForm from "@/components/ContactForm";
import SponsorMarquee from "@/components/SponsorMarquee";
import Donate from "@/components/Donate";
import { scrollToSection } from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Home() {
  const [joinOpen, setJoinOpen] = useState(false);
  const [nomOpen, setNomOpen] = useState(false);
  const [nomEvent, setNomEvent] = useState(null);
  const openNominate = (eventId = null) => {
    setNomEvent(eventId);
    setNomOpen(true);
  };

  useEffect(() => {
    if (window.location.hash === "#membership") {
      const t = setTimeout(() => setJoinOpen(true), 700);
      return () => clearTimeout(t);
    }
    if (window.location.hash === "#contact") {
      const t = setTimeout(() => scrollToSection("#contact"), 700);
      return () => clearTimeout(t);
    }
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <main>
      <Navbar onJoin={() => setJoinOpen(true)} onNominate={() => openNominate()} />
      <Hero onJoin={() => setJoinOpen(true)} />
      <Marquee />
      <SponsorMarquee />
      <NomsOpenBanner onNominate={openNominate} />
      <Volunteer />
      <Manifesto />
      <Classes />
      <Events onNominate={openNominate} />
      <News />
      <Membership open={joinOpen} setOpen={setJoinOpen} />
      <Donate />
      <ContactForm />
      <NominateModal open={nomOpen} setOpen={setNomOpen} preselect={nomEvent} />
      <Footer />
    </main>
  );
}
